import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import VerifyMobileNumber from "../VerifyMobileNumber/VerifyMobileNumber";
import SignUpForm from "./SignupForm";

const SignUp = () => {

    const navigate = useNavigate();

    const [currentState, setCurrentState] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");
    const [formValues, setFormValues] = useState({});
    const [mobileVerify, setMobileVerify] = useState(false);

    const onNextClick = (nextState) => {
        setCurrentState(nextState);
    };

    const currentComponent = () => {
        switch (currentState) {
            case "verifyOtp":
                return (
                    <VerifyMobileNumber
                        mobileNo={mobileNo}
                        onCancelClick={() => onNextClick("")}
                        setCurrentState={setCurrentState}
                        setMobileVerify={setMobileVerify}
                    />
                );

            default:
                return <SignUpForm
                    setMobileNo={setMobileNo}
                    setEmail={setEmail}
                    onNextClick={(msg) => onNextClick(msg)}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    mobileVerify={mobileVerify}

                />;
        }
    };


    return (
        <>
            {currentComponent()}

        </>
    )
}
export default SignUp;